import { formatDate } from "@clipboard-health/date-time";
import { Pill, Text } from "@clipboard-health/ui-components";
import { alpha, Stack } from "@mui/material";
import { Button } from "@src/appV2/redesign/components/Button";
import { BaseTierCard } from "@src/appV2/redesign/Tiers/Cards/BaseTierCard";
import { GoldTierCardWrapper } from "@src/appV2/redesign/Tiers/Cards/GoldTierCardWrapper";
import { TIERS_FULL_PATH } from "@src/appV2/redesign/Tiers/paths";
import { TIERS_PERKS_SECTION_ID } from "@src/appV2/redesign/Tiers/utils/constants";
import { useHistory } from "react-router-dom";

interface GoldTierHeaderSectionProps {
  tierLastChangedAt: Date;
}

export function GoldTierHeaderSection(props: GoldTierHeaderSectionProps) {
  const { tierLastChangedAt } = props;
  const history = useHistory();

  return (
    <GoldTierCardWrapper>
      <BaseTierCard
        title="You're a Gold Member!"
        content={
          <Stack sx={{ justifyContent: "left" }} spacing={2}>
            <Pill
              size="small"
              label={`since ${formatDate(tierLastChangedAt)}`}
              backgroundColor={(theme) => alpha(theme.palette.background.paper, 0.6)}
              sx={{ width: "fit-content" }}
            />

            <Text variant="body1" textAlign="left">
              Your outstanding work has earned you exclusive perks!
            </Text>
          </Stack>
        }
        footer={
          <Button
            invert
            variant="contained"
            size="medium"
            endIconType="chevron-right"
            sx={{ width: "fit-content" }}
            onClick={() => {
              history.replace(`${TIERS_FULL_PATH}#${TIERS_PERKS_SECTION_ID}`);
            }}
          >
            Learn More
          </Button>
        }
      />
    </GoldTierCardWrapper>
  );
}
